import { environment } from '@fund-base/environments/environment';

export const baseApiUrl: string = environment.apiUrl;
export const baseWebUrl: string = environment.webUrl;
export const baseGoogleUrl: string = environment.baseGoogleUrl;
